import styled from "styled-components";
import { Type } from "discover.medical.react-component-library";

export const LabDateInfoText = styled(Type)`
  color: ${({ theme }) => theme.colors.green};
  font-style: normal;
  margin-top: 0.25rem;
`;
